import React, { Component } from 'react';
import styled from '@emotion/styled';
import { SURFACE_COLORS } from 'Style/colors';

export const StyledMobileCommentInput = styled.textarea({
  backgroundColor: SURFACE_COLORS.primary,
  resize: 'none',
  border: 'none',
  '&:focus': {
    backgroundColor: SURFACE_COLORS.primary,
    border: 'none',
  },
});

export interface MobileCommentInputPassedProps {
  beginFocused?: boolean;
  className?: string;
  placeholder?: string;
  onChange: ({ value }: { value: string }) => void;
  focusInput: boolean;
  t: Flipboard.TFunction;
}

type MobileCommentInputProps = MobileCommentInputPassedProps;

class MobileCommentInput extends Component<MobileCommentInputProps> {
  componentDidMount() {
    if (this.props.beginFocused) {
      setTimeout(() => this.focus());
    }
  }
  componentDidUpdate(prevProps: MobileCommentInputProps) {
    if (
      this.props.focusInput &&
      this.props.focusInput !== prevProps.focusInput
    ) {
      this.focus();
    }
  }

  textareaRef = React.createRef<HTMLTextAreaElement>();

  focus = () => {
    this.textareaRef.current?.focus();
  };

  onChange = (e: React.FormEvent<HTMLTextAreaElement>) => {
    this.props.onChange({ value: e.currentTarget.value });
  };

  render() {
    const { className, placeholder } = this.props;
    return (
      <StyledMobileCommentInput
        ref={this.textareaRef}
        onChange={this.onChange}
        className={className}
        placeholder={placeholder}
      />
    );
  }
}

export default MobileCommentInput;
